var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('i',_vm._g(_vm._b({staticClass:"fal fa-circle-question",attrs:{"dark":""}},'i',attrs,false),on))]}}])},'v-tooltip',_vm.attributes,false),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.output)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }